"use client";

import { useState } from "react";
import { useCurrency } from "./CurrencyContext";
import { CURRENCY_OPTIONS, type Currency } from "@/lib/currency";

const LABELS: Record<Currency, { symbol: string; name: string }> = {
  EUR: { symbol: "€", name: "Euro" },
  USD: { symbol: "$", name: "US Dollar" },
  TRY: { symbol: "₺", name: "Turkish Lira" },
};

export default function CurrencySwitcher() {
  const { currency, setCurrency } = useCurrency();
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={() => setOpen(!open)}
        className="bp-mono-sm"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          color: "var(--bp-ink)",
          background: "none",
          border: 0,
          cursor: "pointer",
        }}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Change currency"
      >
        <span aria-hidden="true">{LABELS[currency].symbol}</span>
        <span>{currency}</span>
        <span aria-hidden="true" style={{ fontSize: 9 }}>{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <>
          <div
            onClick={() => setOpen(false)}
            aria-hidden="true"
            style={{ position: "fixed", inset: 0, zIndex: 40 }}
          />
          <div
            role="listbox"
            style={{
              position: "absolute",
              right: 0,
              top: "100%",
              marginTop: 8,
              zIndex: 50,
              background: "var(--bp-bg)",
              border: "1px solid var(--bp-ink)",
              minWidth: 200,
              boxShadow: "0 8px 32px oklch(0.1 0 0 / 0.18)",
            }}
          >
            {CURRENCY_OPTIONS.map((code) => {
              const active = code === currency;
              const label = LABELS[code];
              return (
                <button
                  key={code}
                  onClick={() => {
                    setCurrency(code);
                    setOpen(false);
                  }}
                  role="option"
                  aria-selected={active}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "20px 1fr auto",
                    gap: 12,
                    alignItems: "center",
                    padding: "10px 14px",
                    width: "100%",
                    fontFamily: "var(--bp-mono)",
                    fontSize: 11,
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    color: active ? "var(--bp-bg)" : "var(--bp-ink)",
                    background: active ? "var(--bp-ink)" : "transparent",
                    border: 0,
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                >
                  <span style={{ fontSize: 14 }} aria-hidden="true">
                    {label.symbol}
                  </span>
                  <span style={{ textTransform: "none", letterSpacing: 0, fontFamily: "var(--bp-sans)", fontSize: 13 }}>
                    {label.name}
                  </span>
                  <span style={{ color: active ? "var(--bp-bg)" : "var(--bp-ink-3)" }}>
                    {code}
                  </span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
